module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/util/support/isBufferBrowser.js
// module id = 252
// module chunks = 1